// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"1975":"css/external","2773":"/js/app","6170":"css/app"}[chunkId] + ".css";
};